import React from "react";
import { Redirect } from "react-router";
import { Container, Row, Col } from "shards-react";
import CreateProjectSuperAdmin from "../components/project/CreateProjectSuperAdmin";

class ProjectSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      should_redirect: false,
    };
    this.pathToRedirect = {
      pathname: "/",
      state: {
        type:"",
        message:""
      },
    };
    this.redirectToProjectDetails = this.redirectToProjectDetails.bind(this);
  }

  redirectToProjectDetails(pathname,notify_message) {
    this.pathToRedirect = {
      pathname,
      state: {
        type:notify_message.type,
        message:notify_message.message
      },
    };
    this.setState({ should_redirect: true });
  }

  render() {
    const { should_redirect } = this.state;
    if (should_redirect)
      return (
        <Redirect
          to={{
            ...this.pathToRedirect,
          }}
        />
      );

    return (
      <Container fluid className="main-content-container px-4">
        {/* <Row noGutters className="page-header py-4">
          <PageTitle title="" subtitle="" md="12" className="ml-sm-auto mr-sm-auto" />
        </Row> */}
        <Row className="py-3">
          <Col lg="12">
            <CreateProjectSuperAdmin
              projectId={this.props.match.params.id}
              redirectToProjectDetails={this.redirectToProjectDetails}
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProjectSuperAdmin;
